import { createSlice } from '@reduxjs/toolkit';
import { fetchProductsBestSelling } from '../actions/ProductsBestSellingAction';

const initialState = {
  data: [],
  pagination: {},
  isLoading: false,
  error: null,
};

const productsBestSellingSlice = createSlice({
  name: 'productsBestSelling',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductsBestSelling.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchProductsBestSelling.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.products || [];
        state.pagination = action.payload?.pagination || {};
        state.error = null;
      })
      .addCase(fetchProductsBestSelling.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'حدث خطأ أثناء جلب المنتجات الأكثر مبيعاً';
      });
  },
});

export default productsBestSellingSlice.reducer; 